module.exports = __webpack_public_path__ + "static/media/arc1.f1d6ef84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arc1.jpg
// module id = 5737
// module chunks = 0